









import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { debounce } from 'quasar'

@Component
export default class ItemTopicViewerGapsInput extends Vue {
  text = ''

  @Prop()
  readonly value!: string

  @Prop({ default: false })
  readonly readonly!: boolean

  @Watch('value', { immediate: true })
  update (value: string) {
    if (value !== this.text.trim()) {
      this.text = value || ''
    }
  }

  created () {
    this.respond = debounce(this.respond, 700)
  }

  input (value: string) {
    this.text = value
    this.respond(value)
  }

  respond (value: string) {
    this.$emit('input', value.trim())
  }
}
